// @flow

import React from "react";
import { connect } from "react-redux";
import * as R from "ramda";

import type { State, TempAttachments, ConversationFile } from "src/types";

import { List, ListItem } from "@chakra-ui/react";
import OrgAttachment from "./OrgAttachment";
import TempAttachment from "./TempAttachment";

type Props = {
  attachments: ConversationFile[],
  tempAttachments: TempAttachments,
};

function Attachments({ attachments, tempAttachments }: Props) {
  return attachments.length > 0 || !R.isEmpty(tempAttachments) ? (
    <List spacing={3} width="100%" p={0} mb={0}>
      {attachments.map((file) => (
        <ListItem key={file.name}>
          <OrgAttachment
            id={file.name}
            uploading={false}
            progress={100}
            name={file.originalName}
            size={file.size}
          />
        </ListItem>
      ))}
      {Object.keys(tempAttachments).map((id) => (
        <ListItem key={id}>
          <TempAttachment id={id} />
        </ListItem>
      ))}
    </List>
  ) : null;
}

const mapStateToProps = ({
  app: {
    email: { attachments, tempAttachments },
  },
}: State) => ({
  attachments,
  tempAttachments,
});

export default connect(mapStateToProps, null)(Attachments);
